import { Button, RichTextEditor } from "@/components/ui";
import Input from '@/components/ui/Input/Input';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const FormDataSchema = z.object({
  title: z.string(),
  description: z.string()
});


const TitleAndDescriptionForm = ({handleSave, handleCancel, data}:{handleSave: (data: {title: string; description: string}) => void; handleCancel: () => void; data: z.infer<typeof FormDataSchema> }) => {
    
    const {
            control,
            handleSubmit,
            formState: { errors },
            reset
          } = useForm({
            resolver: zodResolver(FormDataSchema),
            defaultValues: {
              title: data.title ?? '',
              description: data.description ?? '',
            },
            mode: 'all'
          });
        
    return (
      <div className="flex flex-col gap-4 w-full p-4 lg:p-8 bg-[#F2F2F2]">
        <form onSubmit={handleSubmit(handleSave)} className="flex flex-col gap-4">
          <Controller
          name="title"
          control={control}
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="Title"
              label="Title"
              error={errors.title?.message}
              $dataId="inline-title-input"
              
            />
          )}
        />

           <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <RichTextEditor
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="Description"
              label="Description"
              error={errors.description?.message}
            />
          )}
        />
    

            <div className="flex gap-2 justify-end mt-4">
            <Button
              variant="secondary"
              className=""
              onClick={() => {
                handleCancel();
                reset();
              }}
            >
              Cancel
            </Button>
            <Button
              className=""
              onClick={handleSubmit(handleSave)}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    )
  };

  export default TitleAndDescriptionForm;